import { query_client } from '$tablet-app/src/app/query_client';
import { append } from '@akin-home/arrays';
import {
  createChecklistItem,
  parseChecklistItems,
} from '@akin-home/checklists';
import {
  getMinimalTaskList,
  listAllChecklistsQuery,
  updateTaskListMutation,
} from '@akin-home/checklists/frontend';
import { createOutputTextItem } from '../../ChatItem/functions';
import { AddChatItemFunction } from '../../types';
import { AddChecklistItemCommand } from '../types';

const addListItemCommand = async (
  command: AddChecklistItemCommand,
  addItem: AddChatItemFunction
) => {
  const result = AddChecklistItemCommand.safeParse(command);

  if (!result.success) {
    return;
  }

  const {
    data: {
      checklist_id,
      checklist_title,
      not_found_message,
      item_text,
      confidence,
      success_message,
    },
  } = result.data;

  let added = false;

  if (checklist_id?.length) {
    const checklist = (await getMinimalTaskList(checklist_id)).data.getTaskList;

    if (checklist) {
      const list = parseChecklistItems(checklist.checklist);

      await updateTaskListMutation({
        input: {
          id: checklist_id,
          checklist: JSON.stringify(
            append(list, createChecklistItem({ title: item_text }))
          ),
        },
      });

      added = true;
    }
  } else if (checklist_title) {
    const items = await listAllChecklistsQuery({
      query: { title: checklist_title, confidence },
    });

    if (items.length > 0) {
      const { id, checklist = [] } = items[0];

      await updateTaskListMutation({
        input: {
          id,
          checklist: JSON.stringify(
            append(checklist, createChecklistItem({ title: item_text }))
          ),
        },
      });

      added = true;
    }
  }

  if (added) {
    query_client.invalidateQueries('checklists');

    if (success_message?.length) {
      addItem(createOutputTextItem(success_message));
    }
  } else if (not_found_message) {
    addItem(createOutputTextItem(not_found_message));
  }
};

export default addListItemCommand;
